// import Swiper core and required modules
import img1 from "../../assets/imgs/PICTURES/1.jpg"
import img2 from "../../assets/imgs/PICTURES/2.jpg"
import img3 from "../../assets/imgs/PICTURES/3.jpg"
import img4 from "../../assets/imgs/PICTURES/4.jpg"
import img5 from "../../assets/imgs/PICTURES/6.jpg"
import img6 from "../../assets/imgs/PICTURES/7.jpg"
import img8 from "../../assets/imgs/PICTURES/8.jpg"
import img9 from "../../assets/imgs/PICTURES/11.jpg"
import img10 from "../../assets/imgs/PICTURES/9.jpg"
import mainImg from "../../assets/imgs/PICTURES/main.jpg"
import { Swiper, SwiperSlide } from 'swiper/react';
import { Pagination, Navigation, Autoplay } from 'swiper/modules';
// Import Swiper styles
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import 'swiper/css/scrollbar';
import './style.css'
import useWindowSize from "../../components/windowSize/useWindowSize"
import { Box, Typography } from "@mui/material"

export default function Carousel() {
  const size = useWindowSize();
  return (
    <div style={{ width: "100%", margin: "0 auto" }}>

      <Swiper
        slidesPerView={1}
        spaceBetween={1}
        loop={true}

        pagination={{
          clickable: true,
        }}
        navigation={true}
        modules={[Pagination, Navigation, Autoplay]}
        autoplay={{
          delay: 3000,
          disableOnInteraction: false
        }}
        className="mySwiper"
      >

        <SwiperSlide><div style={{ backgroundColor: "#f5f5dc", color: "teal" }}>{/* First slide */}
          <Box sx={{ display: "flex", maxHeight:"350px" }}>

            <img src={mainImg}  width="100%" alt="images" style={{ objectFit: "cover", maxHeight:"300px" }} /> 
            <img src={img2}  width="100%" alt="images" style={{ objectFit: "cover", maxHeight:"300px" }}/>

            {/* <img src={img5} height="250px" width="100%" alt="images"/> */}

          </Box>
          <Box sx={{ height: "70px", display: "flex", justifyContent: "center", margin: "5px 10px" }}>

            <Typography variant="h7" textAlign={"center"} >Meghalaya Society for Social Audit & Transparency(MSSAT) is an independent society set
              up by the Department of Rural Development, Government of Meghalaya to conduct social audits of its flagship programme
              for Mahatma Gandhi National Rural Employment Guarantee Scheme (MGNREGS).</Typography>
          </Box>

        </div>
        </SwiperSlide>
        <SwiperSlide><div style={{ backgroundColor: "#f5f5dc", color: "teal" }}> {/* Second slide */}
          <Box sx={{ display: "flex",maxHeight:"350px",maxHeight:"350px" }}>
            <img src={img3}  width="100%" alt="images" style={{ objectFit: "cover", maxHeight:"300px" }}/>
            <img src={img4}  width="100%" alt="images" style={{ objectFit: "cover", maxHeight:"300px" }}/>

          </Box>
          <Box sx={{ height: "70px", display: "flex", justifyContent: "center", margin: "5px 10px" }}>

            <Typography variant="h7" textAlign={"center"} >At present, MSSAT has been entrusted with the mandate to conduct social audits of Indira
              Awaas Yojana (IAY), a flagship scheme of the Ministry of Rural Development which since inception been providing
              assistance to BPL families who are either houseless or having inadequate housing facilities for constructing a safe
              and durable shelter.</Typography>
          </Box>

        </div>
        </SwiperSlide>
        <SwiperSlide><div style={{ backgroundColor: "#f5f5dc", color: "teal" }}>
          <Box sx={{ display: "flex", maxHeight:"350px" }}>
            <img src={img6}  width="100%" alt="images" style={{ objectFit: "cover", maxHeight:"300px" }}/>
            <img src={img10}  width="80%" alt="images" style={{ objectFit: "cover", maxHeight:"300px" }}/>

            <img src={img1}  width="100%" alt="images" style={{ objectFit: "cover", maxHeight:"300px" }}/>
          </Box>
          <Box sx={{ height: "70px", display: "flex", justifyContent: "center", margin: "5px 10px" }}>

            <Typography variant="h7" textAlign={"center"} >The area of operation of the Society is extend to the whole state of Meghalaya.</Typography>
          </Box>

        </div>
        </SwiperSlide>
      </Swiper>
    </div>
  );
};